import type { Assignment, Campaign, Workspace } from '../types/domain';

export function campaignBelongsToWorkspace(campaign: Campaign, workspace: Workspace | null) {
  const organizationId = workspace?.organizationId;
  if (!organizationId) return true;
  return campaign.owner_organization === organizationId
    || campaign.client === organizationId
    || campaign.operating_agency === organizationId;
}

export function assignmentBelongsToWorkspace(
  assignment: Assignment,
  workspace: Workspace | null,
) {
  const organizationId = workspace?.organizationId;
  if (!organizationId) return true;
  return assignment.owner_organization_id === organizationId
    || assignment.client_id === organizationId
    || assignment.operating_agency_id === organizationId
    || assignment.hired_by === organizationId;
}
